"use client";

import { c as _c } from "react/compiler-runtime";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "cn";
import type * as React from "react";
const toggleVariants = cva(["inline-flex cursor-pointer items-center justify-center gap-1", "whitespace-nowrap shrink-0 text-foreground outline-none", "transition-[color,background-color,border-color,box-shadow]", "focus-visible:ring-[3px] focus-visible:ring-ring/50", "disabled:pointer-events-none disabled:opacity-50", "data-[state=on]:bg-secondary", "[&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0"], {
  variants: {
    variant: {
      ghost: "bg-transparent hover:bg-accent",
      outline: ["border border-border bg-transparent hover:bg-accent", "data-[state=on]:border-ring focus-visible:border-ring"]
    },
    size: {
      sm: "h-8 min-w-8 label-sm px-2",
      default: "h-9 min-w-9 label-md px-3"
    },
    roundness: {
      default: "rounded-sm",
      round: "rounded-full"
    }
  },
  defaultVariants: {
    variant: "ghost",
    size: "default",
    roundness: "default"
  }
});
interface ToggleProps extends React.ComponentProps<typeof TogglePrimitive.Root>, VariantProps<typeof toggleVariants> {}

/** A two-state button, such as a mode that is either on or off. */
function Toggle(t0) {
  const $ = _c(14);
  let className;
  let props;
  let roundness;
  let size;
  let variant;
  if ($[0] !== t0) {
    ({
      className,
      variant,
      size,
      roundness,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = roundness;
    $[4] = size;
    $[5] = variant;
  } else {
    className = $[1];
    props = $[2];
    roundness = $[3];
    size = $[4];
    variant = $[5];
  }
  let t1;
  if ($[6] !== className || $[7] !== roundness || $[8] !== size || $[9] !== variant) {
    t1 = cn(toggleVariants({
      variant,
      size,
      roundness
    }), className);
    $[6] = className;
    $[7] = roundness;
    $[8] = size;
    $[9] = variant;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== props || $[12] !== t1) {
    t2 = <TogglePrimitive.Root data-slot="toggle" className={t1} {...props} />;
    $[11] = props;
    $[12] = t1;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  return t2;
}
export { Toggle, toggleVariants, type ToggleProps };